import React from "react";
import {Shimmer} from "./index";

const PartnersShimmer = () => (
    <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* En-tête de section */}
            <div className="text-center mb-16">
                <Shimmer className="h-10 w-2/3 max-w-xl mx-auto rounded mb-4"/>
                <Shimmer className="h-6 w-full max-w-2xl mx-auto rounded"/>
            </div>

            {/* Catégories de partenaires */}
            <div className="space-y-24">
                {/* Répéter pour chaque catégorie */}
                {[1, 2, 3, 4].map((categoryIndex) => (
                    <div key={categoryIndex} className="relative">
                        {/* En-tête de catégorie */}
                        <div className="flex items-center gap-4 mb-12">
                            <Shimmer className="w-16 h-16 rounded-full"/>
                            <Shimmer className="h-8 w-64 rounded"/>
                        </div>

                        {/* Grille de partenaires */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
                            {/* Répéter pour chaque partenaire */}
                            {[1, 2].map((partnerIndex) => (
                                <div key={partnerIndex} className="group">
                                    <div className="flex items-start space-x-8">
                                        {/* Logo partenaire */}
                                        <Shimmer className="w-24 h-24 rounded-full flex-shrink-0"/>

                                        {/* Contenu partenaire */}
                                        <div className="flex-1">
                                            <Shimmer className="h-6 w-48 rounded mb-2"/>
                                            <Shimmer className="h-4 w-full rounded mb-2"/>
                                            <Shimmer className="h-4 w-3/4 rounded mb-4"/>
                                            <Shimmer className="h-4 w-32 rounded"/>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* Section "Devenez Partenaire" */}
            <div className="mt-24">
                <div className="bg-slate-100 py-16 px-8 rounded-none">
                    <div className="max-w-3xl mx-auto text-center">
                        <Shimmer className="h-8 w-64 mx-auto rounded mb-4"/>
                        <Shimmer className="h-6 w-full max-w-xl mx-auto rounded mb-8"/>
                        <Shimmer className="h-12 w-48 mx-auto rounded"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default PartnersShimmer;